import React, { useState } from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Button,
  Flex,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";
import { setFormModal } from "../redux/slices/modalSlice";
import { setloadTost } from "../redux/slices/toastSlice";

const CorporateFormSchema = Yup.object().shape({
  annualTurnover: Yup.number().required("Annual turnover is required"),
  noOfEmployees: Yup.number().required("Number of employees is required"),
  file: Yup.mixed().required("File is required"),
});

const CorporateUpgradeForm = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const file = values.file;
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Data = reader.result.split(",")[1];
        const payload = {
          annualTurnover: values.annualTurnover,
          noOfEmployees: values.noOfEmployees,
          file: {
            extension: "." + file.name.split(".").pop(),
            data: base64Data,
          },
        };

        const response = await httpRequest(
          `${BASE_URL}/v2/MembershipUpgrade/corporate-application`,
          "post",
          payload
        );

        if (response?.isSuccess) {
          dispatch(setFormModal({ status: false, data: null }));
          dispatch(
            setloadTost({
              title: "Corporate Upgrade",
              description: `Application submitted successfully`,
              status: "success",
              duration: 5000,
              isClosable: true,
              position: "top",
            })
          );
        }
      };
      reader.readAsDataURL(file);
    } catch (err) {
      console.error("Error uploading file", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={{
        annualTurnover: "",
        noOfEmployees: "",
        file: null,
      }}
      validationSchema={CorporateFormSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        values,
      }) => (
        <Form>
          <FormControl
            mt={4}
            isInvalid={errors.annualTurnover && touched.annualTurnover}
          >
            <FormLabel>Annual Turnover</FormLabel>
            <Input
              name="annualTurnover"
              type="number"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.annualTurnover}
            />
            <FormErrorMessage>{errors.annualTurnover}</FormErrorMessage>
          </FormControl>

          <FormControl
            mt={4}
            isInvalid={errors.noOfEmployees && touched.noOfEmployees}
          >
            <FormLabel>Number of Employees</FormLabel>
            <Input
              name="noOfEmployees"
              type="number"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.noOfEmployees}
            />
            <FormErrorMessage>{errors.noOfEmployees}</FormErrorMessage>
          </FormControl>

          <FormControl mt={4} isInvalid={errors.file && touched.file}>
            <FormLabel>Upload File</FormLabel>
            <Input
              name="file"
              type="file"
              onChange={(event) =>
                setFieldValue("file", event.currentTarget.files[0])
              }
            />
            <FormErrorMessage>{errors.file}</FormErrorMessage>
          </FormControl>

          <Flex justifyContent={"center"} gap={5} mt={6}>
            <Button type="submit" colorScheme="teal" isLoading={loading}>
              Submit
            </Button>
            <Button
              variant="ghost"
              onClick={() =>
                dispatch(setFormModal({ status: false, data: null }))
              }
            >
              Cancel
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};

export default CorporateUpgradeForm;
